import {useFetchOneEntry} from 'hec/hooks/useFetchOneEntry'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import modelMap from 'hec/builder/model-map'

export const useFetchFooter = ({name, shouldQuery}) => {
    const config = getConfig()

    return useFetchOneEntry({
        queryKey: [`footer`, name],
        options: {
            model: modelMap.footer,
            apiKey: config.app.builder.api,
            query: {
                name
            }
        },
        enabled: shouldQuery
    })
}
